import { apply } from '@jorgenevens/rest-store/vuex';
import { attach } from '@jorgenevens/rest-store';
import zfhqClient from '@/config/zfhq-api'

import { fetchPage, fetchResource, createResource, updateResource } from '../helpers/actions';
import _mutations from '../helpers/mutations';


export const mutations = {
    ..._mutations
};

export const state = {
    ...apply(attach)
};

export const actions = {

    fetch: fetchResource(options => {
        const _data = {
            include: ''
        }
        return zfhqClient.get(`oauth/applications/${options.id}`, _data);
    }),

    fetchPage: fetchPage(options => {
        const {
            page = 1,
            pageSize = 25,
            filters,
            sort = 'company_name',
            needle
        } = options;

        let _filters = {
            ...filters,
        }

        if (needle) {
            _filters.needle = needle;
        }

        return zfhqClient.get('oauth/applications', {
            sort,
            page: {
                size: pageSize,
                number: page,
            },
            filters: _filters,
        });
    }),

    create: createResource(options => {
        const {
            data
        } = options;

        let _data = {
            application: {
                ...data,
                scopes: data.scopes.join(' ')
            }
        }

        return zfhqClient.post(`oauth/applications`, _data)
    }),

    update: updateResource(options => {
        const {
            id,
            data
        } = options;

        let _data = {
            application: {
                ...data,
                scopes: data.scopes.join(' ')
            }
        }

        return zfhqClient.put(`oauth/applications/${id}`, _data)
    }),

    delete({ commit }, { id }) {
        return zfhqClient.delete(`oauth/applications/${id}`)
            .then(_ => {
                commit('removeResource', { id })
                commit('expireAll')
            })
    },
}